<template>
    <div class="main" style="padding-top:0px">
        <parallax :overlay="false" :classes="'without-img'" style="background-color: #d4d4d4;margin-top: 0px">
            <template slot="content">
                <div>
                    <span class="title-content">
                        <text-lang :lang="lang">
                            <template slot="es">Reportes</template>
                            <template slot="en">Reports</template>
                        </text-lang>
                    </span>
                </div>
            </template>
        </parallax>

        <section class="light-content light-content-secondary">
            <div class="container">
                <list-content class="list-content-download">
                    <list-content-item>
                        <p class="title-content title-content-tertiary">
                            <text-lang :lang="lang">
                                <template slot="es">Documentos Constitutivos</template>
                                <template slot="en">Constitutive Documents</template>
                            </text-lang>
                        </p>
                        <file-download :file="{label: 'ACTA CONSTITUTIVA ICP', path:`./documents/ACTA CONSTITUTIVA ICP 1.pdf`}" />
                    </list-content-item>
                    <list-content-item>
                        <file-download :file="{label: 'ACTA ASAMBLEA 01-04-2019 REGISTRADA', path:`./documents/ACTA ASAMBLEA 01-04-2019 REGISTRADA.pdf`}" />
                    </list-content-item>
                    <list-content-item>
                        <file-download :file="{label: 'Propecto autorizado por la SUNAVAL (Para constitucion de la empresa)', path:`./documents/prospecto.pdf`}" />
                    </list-content-item>
                </list-content>

                <p class="title-content" style="margin-top: 40px">
                    <text-lang :lang="lang">
                        <template slot="es">Reportes y otros</template>
                        <template slot="en">Reports and other</template>
                    </text-lang>
                </p>
                <list-content class="list-content-download">
                    <list-content-item v-for="(file,index) in sunaval" :key="index">
                        <file-download :file="{label: file.label, path:`./documents/SUNAVAL/${file.nameFile}`}" />
                    </list-content-item>
                </list-content>
            </div> <!-- /.container -->
        </section> <!-- /.services -->
    </div>
</template>

<script>
// @ is an alias to /src
import Parallax from '@/components/Parallax.vue'
import ListContent from '@/components/ListContent.vue'
import ListContentItem from '@/components/ListContentItem.vue'
import FileDownload from '@/components/FileDownload'
import TextLang from '@/components/TextLang.vue'
import sunaval from '@/reports_sunaval.js'

export default {
    name: 'SunavalFilings',
    props: ['lang'],
    components: {
        Parallax,
        ListContent,
        ListContentItem,
        FileDownload,
        TextLang
    },
    data() {
        return {
            sunaval: sunaval
        }
    }
}
</script>